import { format } from 'date-fns';

export function formatDatetoString(text: Date | undefined): string {
    if (!text || isNaN(text.getTime())) return '';
    return format(text, 'd/M/yyyy');
}
